import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const DividerWithText = styled('div')`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 20px;
  position: relative;
`;

export const Divider = styled('div')`
  border-bottom: 1px ${colours.neutral[300]} solid;
  flex: 1;
`;

export const DividerWithTextText = styled(Text.P2Semibold)`
  color: black !important;
`;
